import { Box } from '@chakra-ui/react';

import { MobileUserNavigation } from '@r-client/republic/feature/layout';
import { MaybeValue, Viewer } from '@r-client/shared/data/auth';
import {
  useJurisdiction,
  useShowGlobalAuthRegionLinks,
} from '@r-client/shared/feature/global-auth';

interface IMobileUserMenuProps {
  user: {
    viewer: MaybeValue<Viewer>;
    isLoading?: boolean;
  };
  hasBottomBorder?: boolean;
}

export const MobileUserMenu = ({
  user: { viewer, isLoading },
  hasBottomBorder,
}: IMobileUserMenuProps) => {
  const jurisdiction = useJurisdiction();
  const showGlobalAuthRegionLinks = useShowGlobalAuthRegionLinks();
  const hasAccountOutsideUs =
    showGlobalAuthRegionLinks &&
    (jurisdiction.accounts.hasEuAccount || jurisdiction.accounts.hasUkAccount);
  const hasUsAccount =
    showGlobalAuthRegionLinks && jurisdiction.accounts.hasUsAccount;

  if (!isLoading && !viewer?.info && !hasAccountOutsideUs && !hasUsAccount) {
    return null;
  }

  return (
    <Box
      borderTop="1px solid"
      borderBottom={hasBottomBorder ? '1px solid' : undefined}
      borderColor="grey.50"
    >
      <MobileUserNavigation user={viewer?.info} />
    </Box>
  );
};
